import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "bb-match" }
const _hoisted_2 = { class: "bb-match__head" }
const _hoisted_3 = { class: "bb-match__head-tools" }
const _hoisted_4 = { class: "bb-match__body" }
const _hoisted_5 = {
  key: 0,
  class: "bb-match__guide"
}
const _hoisted_6 = {
  key: 0,
  class: "bb-match__sample"
}
const _hoisted_7 = { class: "bb-match__sample-side" }
const _hoisted_8 = {
  key: 0,
  class: "bb-match__sample-name"
}
const _hoisted_9 = { class: "bb-match__sample-val" }
const _hoisted_10 = { class: "bb-match__sample-side" }
const _hoisted_11 = {
  key: 0,
  class: "bb-match__sample-name"
}
const _hoisted_12 = { class: "bb-match__sample-val" }
const _hoisted_13 = {
  key: 1,
  class: "bb-match__tabs",
  role: "tablist"
}
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "bb-match__block" }
const _hoisted_16 = { class: "bb-match__heads" }
const _hoisted_17 = { value: "" }
const _hoisted_18 = ["value"]
const _hoisted_19 = ["value"]
const _hoisted_20 = ["value"]
const _hoisted_21 = ["value"]
const _hoisted_22 = ["disabled"]
const _hoisted_23 = {
  key: 2,
  class: "bb-match__block"
}
const _hoisted_24 = { class: "bb-match__heads" }
const _hoisted_25 = {
  key: 0,
  class: "bb-match__empty"
}
const _hoisted_26 = {
  key: 1,
  class: "bb-match__list"
}
const _hoisted_27 = ["onSubmit"]
const _hoisted_28 = { value: "" }
const _hoisted_29 = ["value"]
const _hoisted_30 = ["value"]
const _hoisted_31 = ["value"]
const _hoisted_32 = ["value"]
const _hoisted_33 = ["disabled"]
const _hoisted_34 = {
  key: 1,
  class: "bb-match__pair"
}
const _hoisted_35 = { class: "bb-match__acts" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = {
  key: 0,
  class: "bb-match__fold"
}
const _hoisted_39 = { class: "bb-match__piece" }
const _hoisted_40 = { class: "bb-match__picker" }
const _hoisted_41 = { class: "bb-match__picker-name" }
const _hoisted_42 = {
  key: 0,
  class: "bb-match__fold bb-match__fold--over"
}
const _hoisted_43 = { class: "bb-match__drop" }
const _hoisted_44 = { class: "bb-match__orgs" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = {
  key: 0,
  class: "bb-match__ways"
}
const _hoisted_47 = ["disabled"]
const _hoisted_48 = ["disabled"]
const _hoisted_49 = ["disabled"]
const _hoisted_50 = {
  key: 3,
  class: "bb-match__error"
}
const _hoisted_51 = { class: "bb-match__foot" }
const _hoisted_52 = { class: "bb-match__foot-main" }
const _hoisted_53 = ["disabled"]
const _hoisted_54 = ["disabled"]
const _hoisted_55 = { class: "bb-match" }
const _hoisted_56 = { class: "bb-match__head" }
const _hoisted_57 = { class: "bb-match__head-tools" }
const _hoisted_58 = { class: "bb-match__body" }
const _hoisted_59 = {
  key: 0,
  class: "bb-match__guide"
}
const _hoisted_60 = {
  key: 0,
  class: "bb-match__sample"
}
const _hoisted_61 = { class: "bb-match__sample-side" }
const _hoisted_62 = {
  key: 0,
  class: "bb-match__sample-name"
}
const _hoisted_63 = { class: "bb-match__sample-val" }
const _hoisted_64 = { class: "bb-match__sample-side" }
const _hoisted_65 = {
  key: 0,
  class: "bb-match__sample-name"
}
const _hoisted_66 = { class: "bb-match__sample-val" }
const _hoisted_67 = {
  key: 1,
  class: "bb-match__hint"
}
const _hoisted_68 = {
  key: 2,
  class: "bb-match__hint"
}
const _hoisted_69 = { class: "bb-match__ways" }
const _hoisted_70 = {
  key: 3,
  class: "bb-match__empty"
}
const _hoisted_71 = {
  key: 4,
  class: "bb-match__empty"
}
const _hoisted_72 = {
  key: 5,
  class: "bb-match__list"
}
const _hoisted_73 = { class: "bb-match__preview-meta" }
const _hoisted_74 = { class: "bb-match__answer" }
const _hoisted_75 = {
  key: 6,
  class: "bb-match__error"
}
const _hoisted_76 = { class: "bb-match__foot" }
const _hoisted_77 = { class: "bb-match__foot-main" }
const _hoisted_78 = ["disabled"]

import { computed, ref, watch } from 'vue';
import { bankbookApi } from '@/services/api';

type Kind = 'account' | 'rel' | 'funding';
type Gubun = 'IN' | 'OUT';

interface CodeOpt { scode: string; sname: string; gubun?: string }
interface MatchRow {
  id: number;
  gubun: Gubun;
  source: string;
  target: string;
  sourceLabel: string;
  targetLabel: string;
}
interface PreviewRow {
  cbIdx: number;
  date: string;
  memo: string;
  price: number;
  before: string;
  after: string;
  patch: Record<string, string>;
}
interface OrgOpt { mCode: string; name: string }

type GuideBlock = {
  title: string;
  lines: string[];
  sample?: { fromLabel?: string; from: string; toLabel?: string; to: string };
};

export default /*@__PURE__*/_defineComponent({
  __name: 'BankbookMatchDialog',
  props: {
    modelValue: { type: Boolean },
    kind: {},
    memberCode: { default: '' },
    year: { default: '' },
    month: { default: '' },
    bizGubun: { default: '' },
    bankCode: { default: '' },
    closedLocked: { type: Boolean, default: false },
    incomeCodes: { default: () => [] },
    expenseCodes: { default: () => [] },
    cbIdxs: { default: () => [] }
  },
  emits: ["update:modelValue", "applied"],
  setup(__props: any, { emit: __emit }) {

const FUNDING = [
  { value: '04', label: '자부담' },
  { value: '05', label: '후원금' },
  { value: '06', label: '수익사업' },
  { value: '07', label: '보조금' },
];

const props = __props;

const emit = __emit;

const gubun = ref<Gubun>('IN');
const rows = ref<MatchRow[]>([]);
const owned = ref(true);
const loading = ref(false);
const saving = ref(false);
const error = ref('');
const importOpen = ref(false);
const previewOpen = ref(false);
const addSource = ref('');
const addTarget = ref('');
const editingId = ref<number | null>(null);
const editSource = ref('');
const editTarget = ref('');
const orgQuery = ref('');
const orgs = ref<OrgOpt[]>([]);
const orgOpen = ref(false);
const selectedOrgName = ref('');
const sourceCode = ref('');
const previewRows = ref<PreviewRow[]>([]);
const previewLoading = ref(false);
const fillMode = ref<'' | 'empty' | 'replace'>('');
const applyOpen = ref(false);
const pickSideOnLoad = ref(false);

const keepHint = computed(() => (
  props.kind === 'funding'
    ? '이미 있는 계정은 그대로 두고, 없는 계정만 가져옴.'
    : '이미 있는 지출 계정은 그대로 두고, 없는 지출 계정만 가져옴.'
));
const replaceHint = computed(() => (
  props.kind === 'funding'
    ? '이 기관의 자금원천 목록을 지우고, 고른 기관 목록으로 바꿈.'
    : '이 기관의 상대계정 목록을 지우고, 고른 기관 목록으로 바꿈.'
));
const scopedCount = computed(() => (props.cbIdxs || []).filter((id) => Number(id) > 0).length);
const guideOpen = ref(false);
const applyGuideOpen = ref(false);
const guideBlocks = computed((): GuideBlock[] => {
  if (props.kind === 'rel') {
    return [
      {
        title: '하는 일',
        sample: { fromLabel: '수입 계정', from: '식재료비수입', toLabel: '지출 계정', to: '생계비' },
        lines: [
          '지출 계정을 보고 상대계정(수입 계정)을 넣음.',
          '왼쪽은 상대계정, 오른쪽은 지출 계정임.',
          '예: 생계비의 상대계정은 식재료비수입.',
          '예: 급여(직접비)의 상대계정은 직원식재료수입.',
        ],
      },
      {
        title: '그대로 두는 내역',
        lines: [
          '수입 내역에는 상대계정을 넣지 않음.',
          '지출 계정이 비어 있으면 넣지 않음.',
          '목록에 없는 지출 계정은 그대로 둠. 예: 수용비 및 수수료',
        ],
      },
      {
        title: '등록',
        lines: ['지출 계정 하나에는 상대계정을 하나만 등록함.'],
      },
      {
        title: '추천',
        lines: [
          '이 기관에 저장한 목록이 없으면 공통 추천을 보여 줌.',
          '저장을 누르면 추천 목록이 이 기관 목록이 됨.',
          '추천을 고치거나 지우면, 저장을 누르지 않아도 추천 목록이 이 기관 목록이 됨.',
          '공통 추천 자체는 바뀌지 않음.',
        ],
      },
      {
        title: '가져오기',
        lines: ['없는 지출 계정만 가져오거나, 목록 전체를 바꿀 수 있음.'],
      },
    ];
  }
  if (props.kind === 'funding') {
    return [
      {
        title: '하는 일',
        sample: { fromLabel: '계정', from: '생계비', toLabel: '자금원천', to: '자부담' },
        lines: [
          '계정을 보고 자금원천을 넣음.',
          '자금원천은 자부담, 후원금, 수익사업, 보조금임.',
          '왼쪽은 계정, 오른쪽은 자금원천임.',
          '예: 생계비는 자부담, 생계비(보조금)는 보조금.',
        ],
      },
      {
        title: '그대로 두는 내역',
        lines: [
          '계정이 비어 있으면 넣지 않음.',
          '목록에 없는 계정은 그대로 둠.',
          '수입에 등록한 계정은 지출 내역에 넣지 않음.',
          '지출에 등록한 계정은 수입 내역에 넣지 않음.',
        ],
      },
      {
        title: '등록',
        lines: ['계정 하나에는 자금원천을 하나만 등록함.'],
      },
      {
        title: '추천',
        lines: [
          '이 기관에 없는 계정만 추천으로 채움.',
          '이미 등록한 계정은 추천으로 바꾸지 않음.',
          '목록에서 지운 계정은 추천으로 다시 채우지 않음.',
        ],
      },
      {
        title: '가져오기',
        lines: ['없는 계정만 가져오거나, 목록 전체를 바꿀 수 있음.'],
      },
    ];
  }
  return [
    {
      title: '하는 일',
      sample: { fromLabel: '계정', from: '본인부담금수입', toLabel: '적요', to: '본인부담' },
      lines: [
        '적요를 보고 계정을 넣음.',
        '왼쪽은 넣을 계정, 오른쪽은 찾을 적요임.',
        '적요에 본인부담이 있으면 본인부담금수입으로 넣음.',
        '숫자와 날짜는 빼고 찾음. 9월 본인부담금도 본인부담금으로 찾음.',
        '본인부담과 본인부담금이 둘 다 맞으면 더 긴 본인부담금을 씀.',
      ],
    },
    {
      title: '그대로 두는 내역',
      lines: [
        '수입에 등록한 적요는 지출 내역에 넣지 않음.',
        '지출에 등록한 적요는 수입 내역에 넣지 않음.',
        '목록에 없는 적요는 그대로 둠. 예: 전기요금',
      ],
    },
    {
      title: '등록',
      lines: [
        '적요는 두 글자부터 등록함.',
        '같은 적요는 한 번만 등록함.',
      ],
    },
    {
      title: '추천',
      lines: [
        '이 기관에 저장한 목록이 없으면 공통 추천을 보여 줌.',
        '저장을 누르면 추천 목록이 이 기관 목록이 됨.',
        '추천을 고치거나 지우면, 저장을 누르지 않아도 추천 목록이 이 기관 목록이 됨.',
        '공통 추천 자체는 바뀌지 않음.',
      ],
    },
    {
      title: '가져오기',
      lines: [
        '다른 기관에서 없는 적요만 가져옴.',
        '이미 있는 적요는 그대로 둠.',
      ],
    },
  ];
});
const applyGuideBlocks = computed((): GuideBlock[] => {
  const tail = [
    '빈 곳만 채우기나 바꾸기를 고른 뒤, 적용하기를 눌러야 통장에 반영됨.',
    scopedCount.value
      ? `체크한 ${scopedCount.value}건만 적용함.`
      : '체크한 내역이 없으면 이번 달 내역을 적용함.',
    '통장을 하나 고르면 그 통장만 적용함.',
    '전체를 고르면 모든 통장에 적용함.',
    '적요 검색과 코드·이름 검색은 화면만 줄이고, 적용 대상은 줄지 않음.',
    '마감한 내역은 바꾸지 않음.',
    '넣을 값이 지금과 같으면 바꾸지 않음.',
    '바꿀 내역이 없으면 적용하기가 눌리지 않음.',
    '끝나면 바뀐 건수를 알려 줌.',
  ];
  const replaceTitle = scopedCount.value ? '고른 항목만 바꾸기' : '이번 달 전부 바꾸기';
  if (props.kind === 'rel') {
    return [
      {
        title: '하는 일',
        sample: { fromLabel: '수입 계정', from: '식재료비수입', toLabel: '지출 계정', to: '생계비' },
        lines: [
          '목록에 있는 지출 계정이면 상대계정을 넣음.',
          '예: 생계비의 상대계정은 식재료비수입.',
          '수입 내역은 바꾸지 않음.',
          '지출 계정이 비어 있거나 목록에 없으면 그대로 둠.',
        ],
      },
      {
        title: '빈 곳만 채우기',
        lines: ['상대계정이 비어 있는 내역만 넣음.'],
      },
      {
        title: replaceTitle,
        lines: ['상대계정이 이미 있어도 목록의 상대계정으로 바꿈.'],
      },
      { title: '적용할 때', lines: tail },
    ];
  }
  if (props.kind === 'funding') {
    return [
      {
        title: '하는 일',
        sample: { fromLabel: '계정', from: '생계비', toLabel: '자금원천', to: '자부담' },
        lines: [
          '목록에 있는 계정이면 자금원천을 넣음.',
          '예: 생계비의 자금원천은 자부담.',
          '계정이 비어 있거나 목록에 없으면 그대로 둠.',
        ],
      },
      {
        title: '빈 곳만 채우기',
        lines: ['자금원천이 비어 있는 내역만 넣음.'],
      },
      {
        title: replaceTitle,
        lines: [
          '자금원천이 이미 있어도 목록의 자금원천으로 바꿈.',
          '예: 생계비(보조금)의 자금원천이 수익사업이어도 보조금으로 바꿈.',
        ],
      },
      { title: '적용할 때', lines: tail },
    ];
  }
  return [
    {
      title: '하는 일',
      sample: { fromLabel: '계정', from: '본인부담금수입', toLabel: '적요', to: '본인부담' },
      lines: [
        '적요가 목록과 맞으면 그 계정으로 넣음.',
        '목록에 없는 적요는 그대로 둠. 예: 전기요금',
      ],
    },
    {
      title: '빈 곳만 채우기',
      lines: ['계정이 비어 있는 내역만 넣음.'],
    },
    {
      title: replaceTitle,
      lines: ['계정이 이미 있어도 목록의 계정으로 바꿈.'],
    },
    { title: '적용할 때', lines: tail },
  ];
});
const title = computed(() => {
  if (props.kind === 'rel') return '상대계정';
  if (props.kind === 'funding') return '자금원천';
  return '계정';
});
const accountFirst = computed(() => props.kind === 'account' || props.kind === 'rel');
const sourceHead = computed(() => {
  if (props.kind === 'account') return '적요';
  if (props.kind === 'rel') return '지출 계정';
  return '계정';
});
const targetHead = computed(() => props.kind === 'rel' ? '수입 계정' : props.kind === 'funding' ? '자금원천' : '계정');
const leftHead = computed(() => accountFirst.value ? targetHead.value : sourceHead.value);
const rightHead = computed(() => accountFirst.value ? sourceHead.value : targetHead.value);
const headTone = (side: 'left' | 'right') => {
  if (props.kind === 'rel') return side === 'left' ? 'is-in' : 'is-out';
  if (side !== 'left') return '';
  return gubun.value === 'IN' ? 'is-in' : 'is-out';
};
const fieldTone = (side: 'left' | 'right') => headTone(side);
const accountTone = (row: MatchRow, side: 'from' | 'to') => {
  if (props.kind === 'rel') return side === 'from' ? 'is-in' : 'is-out';
  if (side !== 'from') return '';
  return row.gubun === 'IN' ? 'is-in' : 'is-out';
};
const visibleRows = computed(() => rows.value.filter((row) => row.gubun === gubun.value));
const sourceOptions = computed(() => (gubun.value === 'IN' ? props.incomeCodes : props.expenseCodes));
const targetOptions = computed(() => {
  if (props.kind === 'funding') return FUNDING;
  if (props.kind === 'rel') return props.incomeCodes.map((code) => ({ value: code.scode, label: code.sname }));
  const list = gubun.value === 'IN' ? props.incomeCodes : props.expenseCodes;
  return list.map((code) => ({ value: code.scode, label: code.sname }));
});
const canAdd = computed(() => addSource.value.trim().length >= (props.kind === 'account' ? 2 : 1) && !!addTarget.value && !saving.value);
const canEdit = computed(() => editSource.value.trim().length >= (props.kind === 'account' ? 2 : 1) && !!editTarget.value && !saving.value);
const canKeep = computed(() => !owned.value && rows.value.length > 0 && !loading.value);

const formatPrice = (value: number) => `${Number(value || 0).toLocaleString('ko-KR')}원`;

const loadRows = async () => {
  if (!props.memberCode) {
    rows.value = [];
    owned.value = true;
    return;
  }
  loading.value = true;
  error.value = '';
  try {
    const res = await bankbookApi.listAutoMatches(props.memberCode, {
      kind: props.kind,
      year: props.year != null ? String(props.year) : undefined,
    });
    rows.value = res.data?.data || [];
    owned.value = res.data?.owned !== false;
    if (pickSideOnLoad.value && props.kind !== 'rel') {
      pickSideOnLoad.value = false;
      const hasIn = rows.value.some((row) => row.gubun === 'IN');
      const hasOut = rows.value.some((row) => row.gubun === 'OUT');
      if (!hasIn && hasOut) gubun.value = 'OUT';
    }
  } catch (err) {
    console.error(err);
    error.value = '목록을 불러오지 못했습니다.';
    rows.value = [];
    owned.value = true;
  } finally {
    loading.value = false;
  }
};

const addRow = async () => {
  if (!props.memberCode || !canAdd.value) return;
  saving.value = true;
  error.value = '';
  try {
    const res = await bankbookApi.saveAutoMatch(props.memberCode, {
      kind: props.kind,
      gubun: props.kind === 'rel' ? 'OUT' : gubun.value,
      source: addSource.value.trim(),
      target: addTarget.value,
    });
    if (res.data?.success === false) {
      error.value = res.data?.message || '추가하지 못했습니다.';
      return;
    }
    addSource.value = '';
    addTarget.value = '';
    await loadRows();
  } catch (err: any) {
    error.value = err?.response?.data?.message || '추가하지 못했습니다.';
  } finally {
    saving.value = false;
  }
};

const startEdit = (row: MatchRow) => {
  editingId.value = row.id;
  editSource.value = row.source;
  editTarget.value = row.target;
};

const saveEdit = async (row: MatchRow) => {
  if (!props.memberCode || !canEdit.value) return;
  const source = editSource.value.trim();
  const target = editTarget.value;
  if (source === row.source && target === row.target) {
    editingId.value = null;
    return;
  }
  saving.value = true;
  error.value = '';
  try {
    const res = await bankbookApi.updateAutoMatch(props.memberCode, row.id, { source, target });
    if (res.data?.success === false) {
      error.value = res.data?.message || '수정하지 못했습니다.';
      return;
    }
    editingId.value = null;
    await loadRows();
  } catch (err: any) {
    error.value = err?.response?.data?.message || '수정하지 못했습니다.';
  } finally {
    saving.value = false;
  }
};

const removeRow = async (id: number) => {
  if (!props.memberCode) return;
  error.value = '';
  try {
    await bankbookApi.deleteAutoMatch(props.memberCode, id);
    await loadRows();
  } catch (err) {
    console.error(err);
    error.value = '지우지 못했습니다.';
  }
};

const pickOrg = (org: OrgOpt) => {
  sourceCode.value = org.mCode;
  selectedOrgName.value = org.name;
  orgOpen.value = false;
};

const openImport = () => {
  orgOpen.value = false;
  if (importOpen.value) {
    importOpen.value = false;
    return;
  }
  previewOpen.value = false;
  importOpen.value = true;
  error.value = '';
  orgQuery.value = '';
  selectedOrgName.value = '';
  sourceCode.value = '';
  orgs.value = [];
  void loadOrgs();
};

const loadOrgs = async () => {
  if (!props.memberCode) return;
  try {
    const res = await bankbookApi.searchAutoMatchSources(props.memberCode, orgQuery.value.trim(), props.kind);
    const list = (res.data?.data || []) as OrgOpt[];
    orgs.value = list.filter((org) => org.mCode);
  } catch (err) {
    console.error(err);
    error.value = '기관을 찾지 못했습니다.';
  }
};

let searchTimer: ReturnType<typeof setTimeout> | null = null;
const searchOrgs = () => {
  if (searchTimer) clearTimeout(searchTimer);
  searchTimer = setTimeout(() => { void loadOrgs(); }, 250);
};

const keepRows = async () => {
  if (!props.memberCode || !canKeep.value) return;
  saving.value = true;
  error.value = '';
  try {
    await bankbookApi.keepAutoMatches(props.memberCode, { kind: props.kind });
    await loadRows();
  } catch (err: any) {
    error.value = err?.response?.data?.message || '저장하지 못했습니다.';
  } finally {
    saving.value = false;
  }
};

const runImport = async (mode: 'add' | 'replace') => {
  if (!props.memberCode || !sourceCode.value) return;
  saving.value = true;
  error.value = '';
  try {
    await bankbookApi.importAutoMatches(props.memberCode, {
      sourceCode: sourceCode.value,
      kinds: [props.kind],
      mode: props.kind === 'account' ? 'add' : mode,
    });
    importOpen.value = false;
    orgOpen.value = false;
    await loadRows();
  } catch (err: any) {
    error.value = err?.response?.data?.message || '가져오지 못했습니다.';
  } finally {
    saving.value = false;
  }
};

const openApply = () => {
  applyOpen.value = true;
  applyGuideOpen.value = false;
  fillMode.value = '';
  previewRows.value = [];
  previewLoading.value = false;
  error.value = '';
};

const pickFill = (mode: 'empty' | 'replace') => {
  fillMode.value = mode;
  void openPreview();
};

const openPreview = async () => {
  if (!props.memberCode || !fillMode.value) return;
  previewRows.value = [];
  previewLoading.value = true;
  error.value = '';
  try {
    const res = await bankbookApi.previewAutoMatches(props.memberCode, {
      year: String(props.year || ''),
      month: String(props.month || ''),
      bizGubun: props.bizGubun || undefined,
      bankCode: props.bankCode || undefined,
      kind: props.kind,
      mode: fillMode.value,
      cbIdxs: scopedCount.value ? props.cbIdxs : undefined,
    });
    previewRows.value = res.data?.data || [];
  } catch (err: any) {
    error.value = err?.response?.data?.message || '목록을 만들지 못했습니다.';
  } finally {
    previewLoading.value = false;
  }
};

const canApply = computed(() => (
  Boolean(fillMode.value)
  && previewRows.value.length > 0
  && !previewLoading.value
  && !saving.value
  && !props.closedLocked
));

const applyResultText = (ok: number, failed: number) => {
  const name = props.kind === 'rel' ? '상대계정' : props.kind === 'funding' ? '자금원천' : '계정';
  if (!ok && !failed) return '적용할 내역이 없음.';
  if (failed && ok) return `${name} ${ok}건은 적용했습니다. ${failed}건은 적용하지 못했습니다.`;
  if (failed) return `${name}을 적용하지 못했습니다.`;
  return `${name} ${ok}건을 적용했습니다.`;
};

const applyPreview = async () => {
  if (!canApply.value) return;
  if (error.value && !previewRows.value.length) {
    alert(error.value);
    return;
  }
  if (!previewRows.value.length) {
    alert(applyResultText(0, 0));
    return;
  }
  saving.value = true;
  error.value = '';
  try {
    const results = await Promise.allSettled(
      previewRows.value.map((row) => bankbookApi.update(row.cbIdx, row.patch))
    );
    const failed = results.filter((result) => result.status === 'rejected').length;
    const ok = results.length - failed;
    if (ok) emit('applied');
    alert(applyResultText(ok, failed));
    if (ok && !failed) applyOpen.value = false;
  } catch (err) {
    console.error(err);
    alert(applyResultText(0, previewRows.value.length));
  } finally {
    saving.value = false;
  }
};

const close = () => {
  importOpen.value = false;
  previewOpen.value = false;
  applyOpen.value = false;
  orgOpen.value = false;
  guideOpen.value = false;
  applyGuideOpen.value = false;
  error.value = '';
  emit('update:modelValue', false);
};

watch(() => props.modelValue, (open) => {
  if (!open) return;
  importOpen.value = false;
  previewOpen.value = false;
  applyOpen.value = false;
  orgOpen.value = false;
  guideOpen.value = false;
  applyGuideOpen.value = false;
  error.value = '';
  addSource.value = '';
  addTarget.value = '';
  editingId.value = null;
  fillMode.value = '';
  gubun.value = props.kind === 'rel' ? 'OUT' : 'IN';
  pickSideOnLoad.value = true;
  void loadRows();
});

watch(() => props.kind, () => {
  guideOpen.value = false;
  editingId.value = null;
  gubun.value = props.kind === 'rel' ? 'OUT' : 'IN';
  if (props.modelValue) void loadRows();
});

watch(gubun, () => {
  editingId.value = null;
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_dialog, {
      "model-value": __props.modelValue,
      "max-width": "520",
      persistent: "",
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (emit('update:modelValue', $event)))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _createElementVNode("h3", null, _toDisplayString(title.value), 1)
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["bb-match__q", { on: guideOpen.value }]),
                title: "설명",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (guideOpen.value = !guideOpen.value))
              }, [
                _createVNode(_component_v_icon, { size: "18" }, {
                  default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                    _createTextVNode("mdi-help-circle-outline", -1)
                  ]))]),
                  _: 1
                })
              ], 2),
              _createElementVNode("button", {
                type: "button",
                class: "bb-match__x",
                title: "닫기",
                onClick: close
              }, [
                _createVNode(_component_v_icon, { size: "18" }, {
                  default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                    _createTextVNode("mdi-close", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            (guideOpen.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(guideBlocks.value, (block, index) => {
                    return (_openBlock(), _createElementBlock("section", { key: index }, [
                      _createElementVNode("strong", null, _toDisplayString(block.title), 1),
                      (block.sample)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                              (block.sample.fromLabel)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(block.sample.fromLabel), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", _hoisted_9, _toDisplayString(block.sample.from), 1)
                            ]),
                            _cache[27] || (_cache[27] = _createElementVNode("em", null, "→", -1)),
                            _createElementVNode("div", _hoisted_10, [
                              (block.sample.toLabel)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(block.sample.toLabel), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", _hoisted_12, _toDisplayString(block.sample.to), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(block.lines, (line, lineIndex) => {
                        return (_openBlock(), _createElementBlock("p", { key: lineIndex }, [
                          _cache[28] || (_cache[28] = _createElementVNode("span", null, "*", -1)),
                          _createTextVNode(_toDisplayString(line), 1)
                        ]))
                      }), 128))
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (__props.kind !== 'rel')
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["is-in", { on: gubun.value === 'IN' }]),
                    disabled: __props.kind === 'rel',
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (gubun.value = 'IN'))
                  }, "수입", 10, _hoisted_14),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["is-out", { on: gubun.value === 'OUT' }]),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (gubun.value = 'OUT'))
                  }, "지출", 2)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("section", _hoisted_15, [
              _cache[35] || (_cache[35] = _createElementVNode("p", { class: "bb-match__sec" }, "조건추가", -1)),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("span", {
                  class: _normalizeClass(headTone('left'))
                }, _toDisplayString(leftHead.value), 3),
                _cache[29] || (_cache[29] = _createElementVNode("span", null, null, -1)),
                _createElementVNode("span", {
                  class: _normalizeClass(headTone('right'))
                }, _toDisplayString(rightHead.value), 3),
                _cache[30] || (_cache[30] = _createElementVNode("span", null, null, -1))
              ]),
              _createElementVNode("form", {
                class: "bb-match__add-row",
                onSubmit: _withModifiers(addRow, ["prevent"])
              }, [
                (accountFirst.value)
                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                      key: 0,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((addTarget).value = $event)),
                      class: _normalizeClass(["bb-match__field", [{ empty: !addTarget.value }, fieldTone('left')]])
                    }, [
                      _createElementVNode("option", _hoisted_17, _toDisplayString(__props.kind === 'rel' ? '상대계정을 선택하세요' : '계정을 선택하세요'), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(targetOptions.value, (opt) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: opt.value,
                          value: opt.value
                        }, _toDisplayString(opt.label), 9, _hoisted_18))
                      }), 128))
                    ], 2)), [
                      [_vModelSelect, addTarget.value]
                    ])
                  : (__props.kind === 'account')
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 1,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((addSource).value = $event)),
                        class: "bb-match__field",
                        type: "text",
                        placeholder: "예: 본인부담",
                        maxlength: "80"
                      }, null, 512)), [
                        [_vModelText, addSource.value]
                      ])
                    : _withDirectives((_openBlock(), _createElementBlock("select", {
                        key: 2,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((addSource).value = $event)),
                        class: _normalizeClass(["bb-match__field", [{ empty: !addSource.value }, fieldTone('left')]])
                      }, [
                        _cache[31] || (_cache[31] = _createElementVNode("option", { value: "" }, "계정을 선택하세요", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sourceOptions.value, (code) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: code.scode,
                            value: code.scode
                          }, _toDisplayString(code.sname), 9, _hoisted_19))
                        }), 128))
                      ], 2)), [
                        [_vModelSelect, addSource.value]
                      ]),
                _cache[34] || (_cache[34] = _createElementVNode("span", {
                  class: "bb-match__arrow",
                  "aria-hidden": "true"
                }, "→", -1)),
                (accountFirst.value && __props.kind === 'account')
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 3,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((addSource).value = $event)),
                      class: "bb-match__field",
                      type: "text",
                      placeholder: "예: 본인부담",
                      maxlength: "80"
                    }, null, 512)), [
                      [_vModelText, addSource.value]
                    ])
                  : (accountFirst.value)
                    ? _withDirectives((_openBlock(), _createElementBlock("select", {
                        key: 4,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((addSource).value = $event)),
                        class: _normalizeClass(["bb-match__field", [{ empty: !addSource.value }, fieldTone('right')]])
                      }, [
                        _cache[32] || (_cache[32] = _createElementVNode("option", { value: "" }, "계정을 선택하세요", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sourceOptions.value, (code) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: code.scode,
                            value: code.scode
                          }, _toDisplayString(code.sname), 9, _hoisted_20))
                        }), 128))
                      ], 2)), [
                        [_vModelSelect, addSource.value]
                      ])
                    : _withDirectives((_openBlock(), _createElementBlock("select", {
                        key: 5,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((addTarget).value = $event)),
                        class: _normalizeClass(["bb-match__field", { empty: !addTarget.value }])
                      }, [
                        _cache[33] || (_cache[33] = _createElementVNode("option", { value: "" }, "자금원천을 선택하세요", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(targetOptions.value, (opt) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: opt.value,
                            value: opt.value
                          }, _toDisplayString(opt.label), 9, _hoisted_21))
                        }), 128))
                      ], 2)), [
                        [_vModelSelect, addTarget.value]
                      ]),
                _createElementVNode("button", {
                  type: "submit",
                  class: "bb-match__add-btn",
                  disabled: !canAdd.value || saving.value
                }, "조건추가", 8, _hoisted_22)
              ], 32)
            ]),
            (loading.value || visibleRows.value.length)
              ? (_openBlock(), _createElementBlock("section", _hoisted_23, [
                  _cache[45] || (_cache[45] = _createElementVNode("p", { class: "bb-match__sec" }, "목록", -1)),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("span", {
                      class: _normalizeClass(headTone('left'))
                    }, _toDisplayString(leftHead.value), 3),
                    _cache[36] || (_cache[36] = _createElementVNode("span", null, null, -1)),
                    _createElementVNode("span", {
                      class: _normalizeClass(headTone('right'))
                    }, _toDisplayString(rightHead.value), 3),
                    _cache[37] || (_cache[37] = _createElementVNode("span", null, null, -1))
                  ]),
                  (loading.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_25, "불러오는 중…"))
                    : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleRows.value, (row) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: row.id
                          }, [
                            (editingId.value === row.id)
                              ? (_openBlock(), _createElementBlock("form", {
                                  key: 0,
                                  class: "bb-match__add-row",
                                  onSubmit: _withModifiers(($event: any) => (saveEdit(row)), ["prevent"])
                                }, [
                                  (accountFirst.value)
                                    ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                        key: 0,
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((editTarget).value = $event)),
                                        class: _normalizeClass(["bb-match__field", [{ empty: !editTarget.value }, fieldTone('left')]])
                                      }, [
                                        _createElementVNode("option", _hoisted_28, _toDisplayString(__props.kind === 'rel' ? '상대계정을 선택하세요' : '계정을 선택하세요'), 1),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(targetOptions.value, (opt) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: opt.value,
                                            value: opt.value
                                          }, _toDisplayString(opt.label), 9, _hoisted_29))
                                        }), 128))
                                      ], 2)), [
                                        [_vModelSelect, editTarget.value]
                                      ])
                                    : _withDirectives((_openBlock(), _createElementBlock("select", {
                                        key: 1,
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((editSource).value = $event)),
                                        class: _normalizeClass(["bb-match__field", [{ empty: !editSource.value }, fieldTone('left')]])
                                      }, [
                                        _cache[38] || (_cache[38] = _createElementVNode("option", { value: "" }, "계정을 선택하세요", -1)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sourceOptions.value, (code) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: code.scode,
                                            value: code.scode
                                          }, _toDisplayString(code.sname), 9, _hoisted_30))
                                        }), 128))
                                      ], 2)), [
                                        [_vModelSelect, editSource.value]
                                      ]),
                                  _cache[41] || (_cache[41] = _createElementVNode("span", {
                                    class: "bb-match__arrow",
                                    "aria-hidden": "true"
                                  }, "→", -1)),
                                  (__props.kind === 'account')
                                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                        key: 2,
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((editSource).value = $event)),
                                        class: "bb-match__field",
                                        type: "text",
                                        placeholder: "예: 본인부담",
                                        maxlength: "80"
                                      }, null, 512)), [
                                        [_vModelText, editSource.value]
                                      ])
                                    : (__props.kind === 'rel')
                                      ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                          key: 3,
                                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((editSource).value = $event)),
                                          class: _normalizeClass(["bb-match__field", [{ empty: !editSource.value }, fieldTone('right')]])
                                        }, [
                                          _cache[39] || (_cache[39] = _createElementVNode("option", { value: "" }, "계정을 선택하세요", -1)),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sourceOptions.value, (code) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                              key: code.scode,
                                              value: code.scode
                                            }, _toDisplayString(code.sname), 9, _hoisted_31))
                                          }), 128))
                                        ], 2)), [
                                          [_vModelSelect, editSource.value]
                                        ])
                                      : _withDirectives((_openBlock(), _createElementBlock("select", {
                                          key: 4,
                                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((editTarget).value = $event)),
                                          class: _normalizeClass(["bb-match__field", { empty: !editTarget.value }])
                                        }, [
                                          _cache[40] || (_cache[40] = _createElementVNode("option", { value: "" }, "자금원천을 선택하세요", -1)),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(targetOptions.value, (opt) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                              key: opt.value,
                                              value: opt.value
                                            }, _toDisplayString(opt.label), 9, _hoisted_32))
                                          }), 128))
                                        ], 2)), [
                                          [_vModelSelect, editTarget.value]
                                        ]),
                                  _createElementVNode("button", {
                                    type: "submit",
                                    class: "bb-match__add-btn",
                                    disabled: !canEdit.value
                                  }, "수정", 8, _hoisted_33)
                                ], 40, _hoisted_27))
                              : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["bb-match__from", accountTone(row, 'from')])
                                  }, _toDisplayString(accountFirst.value ? row.targetLabel : row.sourceLabel), 3),
                                  _cache[44] || (_cache[44] = _createElementVNode("span", {
                                    class: "bb-match__arrow",
                                    "aria-hidden": "true"
                                  }, "→", -1)),
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["bb-match__to", accountTone(row, 'to')])
                                  }, _toDisplayString(accountFirst.value ? row.sourceLabel : row.targetLabel), 3),
                                  _createElementVNode("span", _hoisted_35, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "bb-match__del",
                                      title: "고치기",
                                      onClick: ($event: any) => (startEdit(row))
                                    }, [
                                      _createVNode(_component_v_icon, { size: "16" }, {
                                        default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                                          _createTextVNode("mdi-pencil-outline", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ], 8, _hoisted_36),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "bb-match__del",
                                      title: "지우기",
                                      onClick: ($event: any) => (removeRow(row.id))
                                    }, [
                                      _createVNode(_component_v_icon, { size: "16" }, {
                                        default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                                          _createTextVNode("mdi-close", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ], 8, _hoisted_37)
                                  ])
                                ]))
                          ], 64))
                        }), 128))
                      ]))
                ]))
              : _createCommentVNode("", true),
            _createVNode(_Transition, { name: "bb-unfold" }, {
              default: _withCtx(() => [
                (importOpen.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _cache[50] || (_cache[50] = _createElementVNode("p", { class: "bb-match__sec" }, "가져오기", -1)),
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("button", {
                            type: "button",
                            class: _normalizeClass(["bb-match__picker-btn", { empty: !sourceCode.value }]),
                            onClick: _cache[14] || (_cache[14] = ($event: any) => (orgOpen.value = !orgOpen.value))
                          }, [
                            _createElementVNode("span", _hoisted_41, _toDisplayString(sourceCode.value ? selectedOrgName.value : '기관 고르기'), 1),
                            _createVNode(_component_v_icon, { size: "18" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(orgOpen.value ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                              ]),
                              _: 1
                            })
                          ], 2),
                          _createVNode(_Transition, { name: "bb-unfold" }, {
                            default: _withCtx(() => [
                              (orgOpen.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                    _createElementVNode("div", _hoisted_43, [
                                      _createElementVNode("div", _hoisted_44, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orgs.value, (org) => {
                                          return (_openBlock(), _createElementBlock("button", {
                                            key: org.mCode || 'recommend',
                                            type: "button",
                                            class: _normalizeClass(["bb-match__org", { on: sourceCode.value === org.mCode }]),
                                            onClick: ($event: any) => (pickOrg(org))
                                          }, [
                                            _createElementVNode("span", null, _toDisplayString(org.name), 1)
                                          ], 10, _hoisted_45))
                                        }), 128))
                                      ]),
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((orgQuery).value = $event)),
                                        class: "bb-match__field",
                                        type: "search",
                                        placeholder: "이름 검색",
                                        onInput: searchOrgs
                                      }, null, 544), [
                                        [_vModelText, orgQuery.value]
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        (sourceCode.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                              (__props.kind === 'account')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _cache[46] || (_cache[46] = _createElementVNode("p", { class: "bb-match__note" }, "이미 있는 적요는 그대로 두고, 없는 적요만 가져옴.", -1)),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "bb-match__btn primary",
                                      disabled: saving.value,
                                      onClick: _cache[16] || (_cache[16] = ($event: any) => (runImport('add')))
                                    }, "없는 적요 더하기", 8, _hoisted_47)
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _cache[49] || (_cache[49] = _createElementVNode("p", { class: "bb-match__sec" }, "가져오는 방법", -1)),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "bb-match__way",
                                      disabled: saving.value,
                                      onClick: _cache[17] || (_cache[17] = ($event: any) => (runImport('add')))
                                    }, [
                                      _cache[47] || (_cache[47] = _createElementVNode("strong", null, "없는 것만 가져오기", -1)),
                                      _createElementVNode("span", null, _toDisplayString(keepHint.value), 1)
                                    ], 8, _hoisted_48),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "bb-match__way",
                                      disabled: saving.value,
                                      onClick: _cache[18] || (_cache[18] = ($event: any) => (runImport('replace')))
                                    }, [
                                      _cache[48] || (_cache[48] = _createElementVNode("strong", null, "전부 바꾸기", -1)),
                                      _createElementVNode("span", null, _toDisplayString(replaceHint.value), 1)
                                    ], 8, _hoisted_49)
                                  ], 64))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (error.value && !applyOpen.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_50, _toDisplayString(error.value), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["bb-match__btn ghost", { on: importOpen.value }]),
              onClick: openImport
            }, "가져오기", 2),
            _createElementVNode("div", _hoisted_52, [
              (canKeep.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "bb-match__btn",
                    disabled: saving.value,
                    onClick: keepRows
                  }, "저장", 8, _hoisted_53))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                type: "button",
                class: "bb-match__btn primary",
                disabled: __props.closedLocked,
                onClick: openApply
              }, "다음", 8, _hoisted_54)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["model-value"]),
    _createVNode(_component_v_dialog, {
      modelValue: applyOpen.value,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((applyOpen).value = $event)),
      "max-width": "440",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("div", _hoisted_56, [
            _cache[53] || (_cache[53] = _createElementVNode("div", null, [
              _createElementVNode("h3", null, "적용")
            ], -1)),
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["bb-match__q", { on: applyGuideOpen.value }]),
                title: "설명",
                onClick: _cache[20] || (_cache[20] = ($event: any) => (applyGuideOpen.value = !applyGuideOpen.value))
              }, [
                _createVNode(_component_v_icon, { size: "18" }, {
                  default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                    _createTextVNode("mdi-help-circle-outline", -1)
                  ]))]),
                  _: 1
                })
              ], 2),
              _createElementVNode("button", {
                type: "button",
                class: "bb-match__x",
                title: "닫기",
                onClick: _cache[21] || (_cache[21] = ($event: any) => (applyOpen.value = false))
              }, [
                _createVNode(_component_v_icon, { size: "18" }, {
                  default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
                    _createTextVNode("mdi-close", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_58, [
            (applyGuideOpen.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(applyGuideBlocks.value, (block, index) => {
                    return (_openBlock(), _createElementBlock("section", { key: index }, [
                      _createElementVNode("strong", null, _toDisplayString(block.title), 1),
                      (block.sample)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                            _createElementVNode("div", _hoisted_61, [
                              (block.sample.fromLabel)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_62, _toDisplayString(block.sample.fromLabel), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", _hoisted_63, _toDisplayString(block.sample.from), 1)
                            ]),
                            _cache[54] || (_cache[54] = _createElementVNode("em", null, "→", -1)),
                            _createElementVNode("div", _hoisted_64, [
                              (block.sample.toLabel)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_65, _toDisplayString(block.sample.toLabel), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", _hoisted_66, _toDisplayString(block.sample.to), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(block.lines, (line, lineIndex) => {
                        return (_openBlock(), _createElementBlock("p", { key: lineIndex }, [
                          _cache[55] || (_cache[55] = _createElementVNode("span", null, "*", -1)),
                          _createTextVNode(_toDisplayString(line), 1)
                        ]))
                      }), 128))
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (__props.kind === 'rel')
              ? (_openBlock(), _createElementBlock("p", _hoisted_67, "지출 계정이 있는 내역만 상대계정을 넣을 수 있음."))
              : _createCommentVNode("", true),
            (scopedCount.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_68, "선택한 " + _toDisplayString(scopedCount.value) + "건만 적용함.", 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_69, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["bb-match__way", { on: fillMode.value === 'empty' }]),
                onClick: _cache[22] || (_cache[22] = ($event: any) => (pickFill('empty')))
              }, [...(_cache[56] || (_cache[56] = [
                _createElementVNode("strong", null, "빈 곳만 채우기", -1)
              ]))], 2),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["bb-match__way", { on: fillMode.value === 'replace' }]),
                onClick: _cache[23] || (_cache[23] = ($event: any) => (pickFill('replace')))
              }, [
                _createElementVNode("strong", null, _toDisplayString(scopedCount.value ? '고른 항목만 바꾸기' : '이번 달 전부 바꾸기'), 1)
              ], 2)
            ]),
            (previewLoading.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_70, "확인하는 중…"))
              : (fillMode.value && !previewRows.value.length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_71, "적용할 내역이 없음."))
                : (previewRows.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(previewRows.value, (row) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: row.cbIdx,
                          class: "bb-match__preview"
                        }, [
                          _createElementVNode("div", _hoisted_73, [
                            _createElementVNode("strong", null, _toDisplayString(row.date), 1),
                            _createElementVNode("span", null, _toDisplayString(row.memo || '-'), 1),
                            _createElementVNode("em", null, _toDisplayString(formatPrice(row.price)), 1)
                          ]),
                          _createElementVNode("p", _hoisted_74, _toDisplayString(row.before) + " → " + _toDisplayString(row.after), 1)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
            (error.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_75, _toDisplayString(error.value), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_76, [
            _createElementVNode("div", _hoisted_77, [
              _createElementVNode("button", {
                type: "button",
                class: "bb-match__btn primary",
                disabled: !canApply.value,
                onClick: applyPreview
              }, " 적용하기 ", 8, _hoisted_78)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})